module.exports = __webpack_public_path__ + "c95431d040e853ddba32ef0c6a82f893.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gamers-paradise-empty.png
// module id = 307
// module chunks = 0